import React from 'react';
import './header.css';
import { Back } from '../../constants';

interface HeaderProps {
  title: string;
  actionText?: string;
  onActionClick?: () => void;
  onBackClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, actionText, onActionClick, onBackClick }) => (
  <div className="header">
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <div className="back-icon" onClick={onBackClick}>
        <img src={Back} style={{ height: 30, marginTop: 7 }} alt="back" />
      </div>
      <span className="headertext">{title}</span>
    </div>
    {actionText && (
      <button className="header-action" onClick={onActionClick}>
        {actionText}
      </button>
    )}
  </div>
);

export default Header;
